import * as ex from 'excalibur'
import { leftRoadEdge, rightRoadEdge } from "./constants";

export class RacerTrait implements ex.IActorTrait {
    public throttleOn = false;
    public steerLeft = false;
    public steerRight = false;
    maxSpeed = 300;
    speed = 0;
    accel = 0.1;
    dragScale = 0.99;
    grassDragScale = 0.97;
    turnSpeed = 0.05;

    constructor(maxSpeed?: number, accel?: number) {
        if (maxSpeed !== undefined) {
            this.maxSpeed = maxSpeed;
        }
        if (accel !== undefined) {
            this.accel = accel;
        }
    }

    public update(actor: ex.Actor, engine: ex.Engine, delta: number) {
        if (this.throttleOn) {
            this.speed += this.accel * delta;
        }
        else {
            this.speed *= this.dragScale;
        }

        if (actor.pos.x < leftRoadEdge || actor.pos.x > rightRoadEdge) {
            this.speed *= this.grassDragScale;
        }

        this.speed = Math.min(this.maxSpeed, this.speed);

        let newAngle = actor.rotation;

        if (this.steerLeft && !this.steerRight) {
            newAngle -= this.turnSpeed;
        }
        else if (this.steerRight && !this.steerLeft) {
            newAngle += this.turnSpeed;
        }

        let dir = ex.Vector.fromAngle(newAngle);
        actor.vel = dir.scale(this.speed);
        actor.rotation = newAngle;
    }
}
